import { Fragment } from "react";
import { FormattedMessage } from "react-intl";

import { FormDialog } from "@dzambalaorg/mui-dialog-form";
import { SelectInput, TextInput } from "@dzambalaorg/mui-inputs-core";
import { AvatarInput } from "@dzambalaorg/mui-inputs-image-firebase";
import { RichTextEditor } from "@dzambalaorg/mui-inputs-draft";
import { IMutationProps, useDialogForm } from "@dzambalaorg/react-hooks";
import { ContractStatus, IContract } from "@framework/types";
import { BlockchainInfoPopover } from "@framework/shared";
import { Alert, FormGrid, Typography } from "@dzambalaorg/ui-kit";

import { validationSchema } from "./validation";

export interface ILotteryEditDialogProps extends IMutationProps, Pick<ReturnType<typeof useDialogForm>, "mode"> {
  open: boolean;
  selectedItem: IContract | null;
}

export const LotteryDialogForm = (props: ILotteryEditDialogProps) => {
  const { selectedItem, open, mode, ...rest } = props;

  if (!open || !selectedItem) {
    return null;
  }

  const { id, title, description, imageUrl, contractStatus, address, name, chainId, contractFeatures, parameters } =
    selectedItem;

  const fixedValues = {
    id,
    title,
    description,
    address,
    contractStatus,
    imageUrl,
    parameters,
  };

  return (
    <FormDialog
      open={open}
      initialValues={fixedValues}
      validationSchema={validationSchema}
      message={`dialogs.${mode}`}
      testId="LotteryContractEditForm"
      action={
        mode === "edit" ? (
          <BlockchainInfoPopover name={name} address={address} chainId={chainId} contractFeatures={contractFeatures} />
        ) : null
      }
      filter={({ title, description, imageUrl, contractStatus }) => ({
        title,
        description,
        imageUrl,
        contractStatus,
      })}
      {...rest}
    >
      <FormGrid columns={[1, 2, 1, 3]}>
        <Fragment>
          <Alert severity="warning">
            <Typography>
              <a id="anchor" href={"/chain-link"}>
                <FormattedMessage id="alert.randomChainlink" />
              </a>
            </Typography>
          </Alert>
        </Fragment>

        <TextInput name="title" />
        <SelectInput name="contractStatus" options={ContractStatus} disabledOptions={[ContractStatus.NEW]} />

        <RichTextEditor name="description" />

        <AvatarInput name="imageUrl" />
        <FormGrid.Empty />
        <FormGrid.Empty />
      </FormGrid>
    </FormDialog>
  );
};
